import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Wrapper = styled.div`
  display: flex;
`;
export const RouteContainer = styled.div<{
  fullscreen: boolean;
  canShowBanner: boolean;
}>`
  flex-grow: 1;
  overflow-y: auto;
  width: 100%;
  ${(props) => {
    if (props.canShowBanner) {
      // 50px is the header height and 40px is the banner height
      return ` height: calc(100vh - 50px - 40px);`;
    } else {
      return ` height: calc(100vh - 50px);`;
    }
  }};
`;
